import ApiService from '../api.service';

class Dictionary {
    async getStates() {
        return await ApiService.request('get', 'dictionary/state', {});
    }
}

export default new Dictionary();